var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    fill: "white",
    stroke: "#E0E3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H18C16.9 14 16.01 14.9 16.01 16L16 32C16 33.1 16.89 34 17.99 34H30C31.1 34 32 33.1 32 32V20L26 14ZM18 16H25L30 21V29.58L28.16 27.74C28.7931 26.7797 29.0753 25.6303 28.9586 24.486C28.842 23.3417 28.3338 22.2728 27.52 21.46C27.0585 20.9966 26.5099 20.629 25.9058 20.3785C25.3017 20.1279 24.654 19.9993 24 20C22.6765 20.0003 21.4071 20.5253 20.47 21.46C20.0065 21.9226 19.6387 22.472 19.3878 23.0769C19.1369 23.6817 19.0078 24.3302 19.0078 24.985C19.0078 25.6398 19.1369 26.2883 19.3878 26.8931C19.6387 27.498 20.0065 28.0474 20.47 28.51C21.2831 29.324 22.3528 29.8315 23.4975 29.9463C24.6423 30.0611 25.7915 29.7763 26.75 29.14L29.6 32H18V16ZM26.11 27.1C25.55 27.66 24.8 27.98 24 27.98C23.2 27.98 22.45 27.67 21.89 27.1C21.33 26.54 21.01 25.79 21.01 24.99C21.01 24.19 21.32 23.44 21.89 22.88C22.45 22.31 23.2 22 24 22C24.8 22 25.55 22.31 26.11 22.88C26.67 23.44 26.99 24.19 26.99 24.99C26.99 25.79 26.68 26.54 26.11 27.1Z",
    fill: "#5F6771"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.86ac73cffb74fb9ae1d5c133b1f5a97d.svg";
export { ForwardRef as ReactComponent };